<template>
  <BfAccordion :title="t('setup.parts.handlebar')">
    <template #header-right>
      <BfButton
        :type="ButtonType.Outlined"
        @click.stop="
          router.push({
            name:
              router.currentRoute.value.meta.step === 2
                ? 'handlebarSelection'
                : 'handlebarUpdate',
          })
        "
      >
        {{ t('common.change') }}
      </BfButton>
      <BfBadge
        :color="
          selectedMeasurement?.handlebar.active !== undefined
            ? Colors.Success
            : Colors.Danger
        "
      />
    </template>
    <BfDescriptionList :label="t('setup.handlebar.model')">
      {{
        selectedMeasurement?.handlebar.active
          ? `${selectedMeasurement?.handlebar.active.HANDLEBAR_BRAND} ${selectedMeasurement?.handlebar.active.HANDLEBAR_MODEL}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.handlebar.width')">
      {{
        selectedMeasurement?.handlebar.active
          ? `${selectedMeasurement?.handlebar.active.HANDLEBAR_WIDTH} ${t('common.unit.mm')}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.handlebar.reach')">
      {{
        selectedMeasurement?.handlebar.active
          ? `${selectedMeasurement?.handlebar.active.HANDLEBAR_REACH} ${t('common.unit.mm')}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.handlebar.drop')">
      {{
        selectedMeasurement?.handlebar.active
          ? `${selectedMeasurement?.handlebar.active.HANDLEBAR_DROP} ${t('common.unit.mm')}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.handlebar.backSweepFlare')">
      {{
        selectedMeasurement?.handlebar.active
          ? `${selectedMeasurement?.handlebar.active.BACK_SWEEP_ANGLE} ${t('common.unit.degreesSign')}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.handlebar.flareAngle')">
      {{
        selectedMeasurement?.handlebar.active
          ? `${selectedMeasurement?.handlebar.active.FLARE_ANGLE} ${t('common.unit.degreesSign')}`
          : '-'
      }}
    </BfDescriptionList>
  </BfAccordion>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)
</script>

<style lang="scss"></style>
